import posthog from 'posthog-js';

const onAccept = (): void => {
  if (typeof window !== 'undefined') {
    posthog.opt_in_capturing();
  }
};

export default onAccept;
